export default __webpack_public_path__ + "static/life-grid-gray-blue-min-a765cd62d2103395db2050e360029550.png";